function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 40,
    viewBox: "0 0 70 70"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.474 70a6.97 6.97 0 0 1-5.557-2.764L3.049 43.639a6.971 6.971 0 0 1 11.116-8.414l11.752 15.518L55.474 3.285a6.977 6.977 0 0 1 9.604-2.232 6.97 6.97 0 0 1 2.23 9.602l-34.916 56.06A6.97 6.97 0 0 1 26.474 70",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgCheck;